export const getTerminology = (type) => {
    const map = {
        academy: {
            institution: 'Academy',
            course: 'Course',
            courses: 'Courses',
            batch: 'Batch',
            batches: 'Batches',
            student: 'Student',
            students: 'Students'
        },
        school: {
            institution: 'School',
            course: 'Class',
            courses: 'Classes',
            batch: 'Section',
            batches: 'Sections',
            student: 'Student',
            students: 'Students'
        },
        institute: {
            institution: 'Institute',
            course: 'Course',
            courses: 'Courses',
            batch: 'Batch',
            batches: 'Batches',
            student: 'Student',
            students: 'Students'
        }
    };

    return map[type] || map.academy;
};
